(() => {
  const initializedSections = new WeakSet();

  function initializeBuildYourBox(section) {
    if (!section || initializedSections.has(section)) return;

    const cardItems = Array.from(
      section.querySelectorAll('[data-card-item]')
    );

    const countDisplay = section.querySelector('.selected-count');
    const summaryList = section.querySelector('.selected-summary');
    const addBoxButton = section.querySelector('.add-box-button');
    const giftBoxVariantInput = section.querySelector(
      '.gift-box-variant-id'
    );

    const giftToInput = section.querySelector('.gift-to');
    const giftFromInput = section.querySelector('.gift-from');
    const giftMessageInput = section.querySelector('.gift-message');
    const cartStatus = section.querySelector('.cart-status');

    const zoomModal = section.querySelector('.zoom-modal');
    const zoomImage = section.querySelector('.zoom-image');
    const zoomClose = section.querySelector('.zoom-close');
    const zoomToggle = section.querySelector('.zoom-toggle');

    if (
      !cardItems.length ||
      !countDisplay ||
      !summaryList ||
      !addBoxButton ||
      !giftBoxVariantInput
    ) {
      console.warn(
        'Build Your Own Box: required elements are missing.',
        section
      );

      return;
    }

    initializedSections.add(section);

    const maxCards = Number.parseInt(
      section.dataset.maxCards || '6',
      10
    );

    const selections = new Map();

    let isAdding = false;
    let lastFocusedZoomButton = null;

    function getTotalSelected() {
      let total = 0;

      selections.forEach((item) => {
        total += item.quantity;
      });

      return total;
    }

    function getCardData(cardItem) {
      return {
        variantId: String(cardItem.dataset.variantId || ''),
        title:
          cardItem.dataset.productTitle || 'Greeting Card',
        //price: cardItem.dataset.productPrice || '',
        imageUrl: cardItem.dataset.imageUrl || '',
        cardItem
      };
    }

    function setStatus(message = '', isError = false) {
      if (!cartStatus) return;

      cartStatus.textContent = message;
      cartStatus.classList.toggle('is-error', isError);
    }

    function updateCardControls() {
      const totalSelected = getTotalSelected();

      cardItems.forEach((cardItem) => {
        const variantId = String(
          cardItem.dataset.variantId || ''
        );

        const selection = selections.get(variantId);
        const quantity = selection
          ? selection.quantity
          : 0;

        const minusButton = cardItem.querySelector(
          '.quantity-minus'
        );

        const plusButton = cardItem.querySelector(
          '.quantity-plus'
        );

        const quantityValue = cardItem.querySelector(
          '.quantity-value'
        );

        if (quantityValue) {
          quantityValue.textContent = String(quantity);
        }

        if (minusButton) {
          minusButton.disabled =
            quantity <= 0 || isAdding;
        }

        if (plusButton) {
          plusButton.disabled =
            totalSelected >= maxCards || isAdding;
        }

        cardItem.classList.toggle(
          'selected',
          quantity > 0
        );
      });
    }

    function createSummaryItem(selection) {
      const listItem = document.createElement('li');

      listItem.className = 'summary-item';
      listItem.dataset.variantId =
        selection.variantId;

      if (selection.imageUrl) {
        const image = document.createElement('img');

        image.className = 'summary-thumbnail';
        image.src = selection.imageUrl;
        image.alt = '';
        image.width = 62;
        image.height = 78;
        image.loading = 'lazy';

        listItem.appendChild(image);
      } else {
        const imagePlaceholder =
          document.createElement('div');

        imagePlaceholder.className =
          'summary-thumbnail';

        imagePlaceholder.setAttribute(
          'aria-hidden',
          'true'
        );

        listItem.appendChild(imagePlaceholder);
      }

      const content = document.createElement('div');

      content.className =
        'summary-item-content';

      const title = document.createElement('p');

      title.className = 'summary-item-title';
      title.textContent = selection.title;

      content.appendChild(title);

      //if (selection.price) {
        //const price = document.createElement('p');

        //price.className = 'summary-item-price';
        //price.textContent = selection.price;

        //content.appendChild(price);
      //}

      listItem.appendChild(content);

      const actions = document.createElement('div');

      actions.className =
        'summary-item-actions';

      const removeButton =
        document.createElement('button');

      removeButton.type = 'button';
      removeButton.className = 'summary-remove';
      removeButton.dataset.summaryAction =
        'remove';

      removeButton.setAttribute(
        'aria-label',
        `Remove ${selection.title}`
      );

      removeButton.textContent = '×';

      actions.appendChild(removeButton);

      const quantityControls =
        document.createElement('div');

      quantityControls.className =
        'summary-quantity';

      const minusButton =
        document.createElement('button');

      minusButton.type = 'button';
      minusButton.dataset.summaryAction =
        'minus';

      minusButton.setAttribute(
        'aria-label',
        `Decrease ${selection.title} quantity`
      );

      minusButton.textContent = '−';

      const quantityValue =
        document.createElement('span');

      quantityValue.className =
        'summary-quantity-value';

      quantityValue.textContent =
        String(selection.quantity);

      quantityValue.setAttribute(
        'aria-live',
        'polite'
      );

      const plusButton =
        document.createElement('button');

      plusButton.type = 'button';
      plusButton.dataset.summaryAction =
        'plus';

      plusButton.setAttribute(
        'aria-label',
        `Increase ${selection.title} quantity`
      );

      plusButton.textContent = '+';

      plusButton.disabled =
        getTotalSelected() >= maxCards;

      quantityControls.append(
        minusButton,
        quantityValue,
        plusButton
      );

      actions.appendChild(quantityControls);
      listItem.appendChild(actions);

      return listItem;
    }

    function renderSummary() {
      summaryList.replaceChildren();

      if (selections.size === 0) {
        const emptyItem =
          document.createElement('li');

        emptyItem.className = 'summary-empty';

        emptyItem.textContent =
          'Choose your first greeting card.';

        summaryList.appendChild(emptyItem);

        return;
      }

      selections.forEach((selection) => {
        summaryList.appendChild(
          createSummaryItem(selection)
        );
      });
    }

    function updateInterface() {
      const totalSelected =
        getTotalSelected();

      countDisplay.textContent =
        `${totalSelected} of ${maxCards} selected`;

      addBoxButton.disabled =
        totalSelected !== maxCards || isAdding;

      updateCardControls();
      renderSummary();
    }

    function increaseSelection(cardItem) {
      if (
        isAdding ||
        getTotalSelected() >= maxCards
      ) {
        return;
      }

      const cardData = getCardData(cardItem);

      if (!cardData.variantId) return;

      const existingSelection =
        selections.get(cardData.variantId);

              if (existingSelection) {
        existingSelection.quantity += 1;
      } else {
        selections.set(cardData.variantId, {
          ...cardData,
          quantity: 1
        });
      }

      setStatus();
      updateInterface();
    }

    function decreaseSelection(variantId) {
      if (isAdding) return;

      const selection = selections.get(
        String(variantId)
      );

      if (!selection) return;

      selection.quantity -= 1;

      if (selection.quantity <= 0) {
        selections.delete(String(variantId));
      }

      setStatus();
      updateInterface();
    }

    function removeSelection(variantId) {
      if (isAdding) return;

      selections.delete(String(variantId));

      setStatus();
      updateInterface();
    }

    function resetBuilder() {
      selections.clear();

      if (giftToInput) {
        giftToInput.value = '';
      }

      if (giftFromInput) {
        giftFromInput.value = '';
      }

      if (giftMessageInput) {
        giftMessageInput.value = '';
      }

      updateInterface();
    }

    function openZoom(button) {
      if (!zoomModal || !zoomImage) return;

      const imageUrl =
        button.dataset.zoomImage;

      if (!imageUrl) return;

      lastFocusedZoomButton = button;

      zoomImage.src = imageUrl;
      zoomImage.alt =
        button.dataset.zoomAlt || '';

      zoomImage.classList.remove(
        'is-zoomed'
      );
/*
      if (zoomToggle) {
        zoomToggle.textContent =
          'Zoom 150%';

        zoomToggle.setAttribute(
          'aria-label',
          'Zoom image to 150 percent'
        );
      }
*/
      zoomModal.hidden = false;

      document.body.classList.add(
        'byob-modal-open'
      );

      if (zoomClose) {
        zoomClose.focus();
      }
    }

    function closeZoom() {
      if (
        !zoomModal ||
        zoomModal.hidden
      ) {
        return;
      }

      zoomModal.hidden = true;

      document.body.classList.remove(
        'byob-modal-open'
      );

      if (zoomImage) {
        zoomImage.classList.remove(
          'is-zoomed'
        );

        zoomImage.removeAttribute('src');
        zoomImage.alt = '';
      }

      if (lastFocusedZoomButton) {
        lastFocusedZoomButton.focus();
      }

      lastFocusedZoomButton = null;
    }
/*
    function toggleZoom() {
      if (!zoomImage || !zoomToggle) {
        return;
      }

      const isZoomed =
        zoomImage.classList.toggle(
          'is-zoomed'
        );

      zoomToggle.textContent = isZoomed
        ? 'Reset Zoom'
        : 'Zoom 150%';

      zoomToggle.setAttribute(
        'aria-label',
        isZoomed
          ? 'Reset image zoom'
          : 'Zoom image to 150 percent'
      );
    }
*/
    async function getCart() {
      const response = await fetch(
        `${
          window.Shopify?.routes?.root || '/'
        }cart.js`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          'The cart could not be refreshed.'
        );
      }

      return response.json();
    }

    function updateVisibleCartCounts(cart) {
      const count = Number(
        cart?.item_count || 0
      );

      const countSelectors = [
        '[data-cart-count]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '.cart-count-bubble .cart-count',
        '.cart-count'
      ];

      document
        .querySelectorAll(
          countSelectors.join(',')
        )
        .forEach((element) => {
          element.textContent =
            String(count);
        });

      document
        .querySelectorAll(
          '.cart-count-bubble'
        )
        .forEach((bubble) => {
          bubble.classList.toggle(
            'hidden',
            count === 0
          );
        });
    }

    function announceCartUpdate(
      cart,
      addedData
    ) {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart,
            source:
              'build-your-own-box',
            addedData
          }
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart,
            source:
              'build-your-own-box'
          }
        })
      );

      window.dispatchEvent(
        new CustomEvent('cart:update', {
          detail: {
            resource: cart,
            source:
              'build-your-own-box'
          }
        })
      );
    }

    async function addGiftBoxToCart() {
      const totalSelected =
        getTotalSelected();

      if (
        isAdding ||
        totalSelected !== maxCards
      ) {
        return;
      }

      const giftBoxVariantId =
  String(giftBoxVariantInput.value || '').trim();

if (!/^\d+$/.test(giftBoxVariantId)) {
        
        setStatus(
          'The gift box variant is missing or invalid.',
          true
        );

        return;
      }

      const giftProperties = {};

      const giftTo =
        giftToInput?.value.trim();

      const giftFrom =
        giftFromInput?.value.trim();

      const giftMessage =
        giftMessageInput?.value.trim();

      if (giftTo) {
        giftProperties.To = giftTo;
      }

      if (giftFrom) {
        giftProperties.From =
          giftFrom;
      }

      if (giftMessage) {
        giftProperties[
          'Gift Message'
        ] = giftMessage;
      }

  Array.from(
  selections.values()
).forEach((selection, index) => {
  giftProperties[
  `Card ${index + 1}`
] = `${selection.title} — Quantity: ${selection.quantity}`;
});

const items = [
  {
    id: giftBoxVariantId,
    quantity: 1,
    properties: giftProperties
  }
];

isAdding = true;

      addBoxButton.textContent =
        'Adding...';

      setStatus();
      updateCardControls();

            try {
        const response = await fetch(
          `${
            window.Shopify?.routes?.root || '/'
          }cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body: JSON.stringify({
  items,
  sections: Array.from(
    document.querySelectorAll(
      'cart-items-component[data-section-id]'
    )
  )
    .map((component) => component.dataset.sectionId)
    .filter(Boolean),
  sections_url: window.location.pathname
})
          }
        );

        const responseData =
          await response.json();

        if (!response.ok) {
          throw new Error(
            responseData?.description ||
              responseData?.message ||
              'The gift box could not be added to the cart.'
          );
        }

        const sectionId =
  document.querySelector(
    'cart-items-component[data-section-id]'
  )?.dataset.sectionId;

const returnedSection =
  sectionId &&
  responseData.sections?.[sectionId];

const cartItemsComponent =
  document.querySelector(
    'cart-items-component'
  );

if (returnedSection && cartItemsComponent) {
  const parsedSection =
    new DOMParser().parseFromString(
      returnedSection,
      'text/html'
    );

  const updatedCartItems =
    parsedSection.querySelector(
      'cart-items-component'
    );

  if (updatedCartItems) {
    cartItemsComponent.innerHTML =
      updatedCartItems.innerHTML;
  }
}

const cartDrawer =
  document.querySelector(
    'cart-drawer-component'
  );

if (cartDrawer) {
  cartDrawer.open();
}

        addBoxButton.textContent =
          'Added ✓';

        setStatus(
          'Your gift box was added to the cart.'
        );

        window.setTimeout(() => {
          resetBuilder();

          addBoxButton.textContent =
            'Add Gift Box to Cart';

          isAdding = false;

          updateInterface();
        }, 1800);
      } catch (error) {
        console.error(
          'Build Your Own Box cart error:',
          error
        );

        isAdding = false;

        addBoxButton.textContent =
          'Add Gift Box to Cart';

        setStatus(
          error instanceof Error
            ? error.message
            : 'The gift box could not be added to the cart.',
          true
        );

        updateInterface();
      }
    }

    section.addEventListener(
      'click',
      (event) => {
        const plusButton =
          event.target.closest(
            '.quantity-plus'
          );

        if (
          plusButton &&
          section.contains(plusButton)
        ) {
          const cardItem =
            plusButton.closest(
              '[data-card-item]'
            );

          if (cardItem) {
            increaseSelection(cardItem);
          }

          return;
        }

        const minusButton =
          event.target.closest(
            '.quantity-minus'
          );

        if (
          minusButton &&
          section.contains(minusButton)
        ) {
          const cardItem =
            minusButton.closest(
              '[data-card-item]'
            );

          if (cardItem) {
            decreaseSelection(
              cardItem.dataset.variantId
            );
          }

          return;
        }

        const summaryButton =
          event.target.closest(
            '[data-summary-action]'
          );

        if (
          summaryButton &&
          section.contains(summaryButton)
        ) {
          const summaryItem =
            summaryButton.closest(
              '.summary-item'
            );

          if (!summaryItem) return;

          const variantId =
            summaryItem.dataset.variantId;

          const action =
            summaryButton.dataset
              .summaryAction;

          if (action === 'plus') {
            const selection =
              selections.get(
                String(variantId)
              );

            if (selection) {
              increaseSelection(
                selection.cardItem
              );
            }
          }

          if (action === 'minus') {
            decreaseSelection(
              variantId
            );
          }

          if (action === 'remove') {
            removeSelection(
              variantId
            );
          }

          return;
        }

        const imageButton =
          event.target.closest(
            '.card-image-button'
          );

        if (
          imageButton &&
          section.contains(imageButton)
        ) {
          openZoom(imageButton);

          return;
        }

        if (event.target === zoomModal) {
          closeZoom();
        }
      }
    );

    addBoxButton.addEventListener(
      'click',
      addGiftBoxToCart
    );

    zoomClose?.addEventListener(
      'click',
      closeZoom
    );
/*
    zoomToggle?.addEventListener(
      'click',
      toggleZoom
    );

    zoomImage?.addEventListener(
      'click',
      toggleZoom
    );
*/
    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape' &&
          zoomModal &&
          !zoomModal.hidden
        ) {
          closeZoom();
        }
      }
    );

    updateInterface();
  }

    function initializeAll(root = document) {
    if (
      root.matches?.(
        '[data-build-your-box]'
      )
    ) {
      initializeBuildYourBox(root);
    }

    root
      .querySelectorAll?.(
        '[data-build-your-box]'
      )
      .forEach(
        initializeBuildYourBox
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAll(event.target);
    }
  );
})();